import React from 'react';
import {createUseStyles} from 'react-jss';

const FixedBackground = ({ children, onClick }) => {
  const classes = useStyles();
  return (
    <div
      className={classes.container}
      onClick={onClick ? () => onClick() : () => {}}
    >
      {children}
    </div>
  );
};

const useStyles = createUseStyles({
  '@global': {
    body: { overflow: 'hidden' },
  },
  container: {
    position: 'fixed',
    backgroundColor: 'rgba(55, 55, 55, 0.3)',
    top: 0,
    left: '64px',
    width: '100%',
    height: '100vh',
    zIndex: 10,
    overflow: 'hidden',
  },
  '@media (max-width: 1023px)': {
    container: {
      left: 0,
    },
  },
});
export default FixedBackground;
